import script from "./Privacy.vue?vue&type=script&setup=true&lang=js"
export * from "./Privacy.vue?vue&type=script&setup=true&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=badd68a6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-badd68a6"]])

export default __exports__